import { FlowConfigEyeCatcher, FlowConfigPlayer } from './flow.type';

export type Team = {
    id: number;
    organisation_id: number;
    user_id: number;
    personal_team: boolean;
    testing: boolean;
    code: string;
    url: string;
    name: string;
    created_at: string;
    updated_at: string;
    installation_verified_at: string;
    trial_ends_at?: string | null;
    config: TeamConfig;
    language: TeamLanguage;
    status: TeamStatus;
    impression_status: ImpressionsStatus;
    emergency_stop_at?: string | null;
    disabled_at?: string | null;
    utm_enabled?: boolean;
    utm_medium?: string | null;
};

export const ON_TRIAL_TEAM_STATUS = 'on_trial';
export const TRIAL_EXPIRED_TEAM_STATUS = 'trial_expired';
export const SUBSCRIBED_TEAM_STATUS = 'not_on_trial';

export type TeamStatus =
    | typeof ON_TRIAL_TEAM_STATUS
    | typeof TRIAL_EXPIRED_TEAM_STATUS
    | typeof SUBSCRIBED_TEAM_STATUS;

export const IMPRESSIONS_STATUS_OK = 'ok';
export const IMPRESSIONS_STATUS_APPROACHING_LIMIT = 'approaching_limit';
export const IMPRESSIONS_STATUS_LIMIT_REACHED = 'limit_reached';
export const IMPRESSIONS_STATUS_OVER_LIMIT = 'over_limit';

export type ImpressionsStatus =
    | typeof IMPRESSIONS_STATUS_OK
    | typeof IMPRESSIONS_STATUS_APPROACHING_LIMIT
    | typeof IMPRESSIONS_STATUS_LIMIT_REACHED
    | typeof IMPRESSIONS_STATUS_OVER_LIMIT;

export type TeamLanguage = 'en' | 'en-gb' | 'en-us';

export type TeamConfig = {
    player: TeamConfigPlayer;
    pipeline: TeamConfigPipeline;
    eyeCatcher: FlowConfigEyeCatcher;
};

export type TeamConfigPlayer = Omit<FlowConfigPlayer<any>, 'videos'> & {
    soundPreferenceVariant: 1 | 2;
};

export type TeamConfigPipeline = {
    dictionary: TeamConfigPipelineDictionaryItem[];
};

export type TeamConfigPipelineDictionaryItem = string;

// export type TeamConfigPipelineDictionaryItem = {
//     input: string;
//     output: string;
// };
